import React, { Component } from 'react';
import { Line } from 'rc-progress';

export default class TestReport extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    if (this.props.testState !== "done") {
      return null;
    }
    let errorMsg, warningMsg;
    if (this.props.events.warnings.length > 0) {
      warningMsg = (
          <div>
            <p>Al momento de la videoconferencia, debes prestar atención a los siguientes detalles:</p>
            <ul>
              {this.props.events.warnings.map((event, index) =>
                  <li key={index}>
                    {event}
                  </li>
              )}
            </ul>
        </div>
      );
    }
    if (this.props.events.errors.length > 0) {
      errorMsg = (
          <div>
            <p>Se han encontrado los siguientes errores:</p>
            <ul>
              {this.props.events.errors.map((event, index) =>
                <li key={index}>
                  {event}
                </li>
              )}
            </ul>
            <p>
              Su equipo no es compatible con nuestro sistema de videoconferencias. Si corrige el error puede intentar
              nuevamente la prueba.
            </p>
        </div>
      );
    } else {
      errorMsg = <p>Pruebas realizadas correctamente. Puedes continuar presionando en el botón "Siguiente".</p>;
    }
    return (
      <div>
        <h4>Resultado</h4>
        {warningMsg}
        {errorMsg}
      </div>
    );
  }
}
